import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addNewElevation } from '../../../../store/actions/sketchActions';
import Loader from 'react-loader-spinner';

import { get } from 'lodash'

class NewElevation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: "",

            descriptionCount: 0,
            description: "",

            elevationFiles: [],
        }
    }

    /// README: TITLE AND DESCRIPTION STATE CHANGES
    handleChange = (e) => {
        switch (e.target.id) {
            case "newTitle": {
                this.setState({
                    title: e.target.value,
                })
                break;
            }
            case "newDescription": {
                this.setState({
                    descriptionCount: e.target.value.length,
                    description: e.target.value,
                })
                break;
            }
            default:
        }
    }

    /// README: UTILS
    toLowercaseWithoutSpaces = (val) => {
        return val.replaceAll(/[/\-.\s]/g, '').toLowerCase();
    }

    removePdfExt = (val) => {
        const extLength = 'pdf'.length;
        return val.substring(0, val.length - extLength);
    }

    processFilenames = (filename) => {
        return this.removePdfExt(this.toLowercaseWithoutSpaces(filename));
    }

    /// README: HANDLING PDF FILES ADDITIONS
    onFilesAddHandler = (e) => {
        if (this.maxSelectFile(e) && this.checkMimeType(e) && this.checkFileSize(e)) {
            var elevationFiles = e.target.files;
            this.setState(() => ({ elevationFiles: [...elevationFiles] }));
        }
    }

    maxSelectFile = (e) => {
        let files = e.target.files
        if (files.length > 100) {
            const msg = 'Only 100 files can be attached with elevation'
            e.target.value = null
            alert(msg)
            return false;
        }
        return true;
    }

    checkFileSize = (e) => {
        let files = e.target.files
        let size = 5242880;
        let err = "";
        for (var x = 0; x < files.length; x++) {
            if (files[x].size > size) {
                err = 'File is too large, please pick a smaller file\n';
            }
        };
        if (err !== '') {
            e.target.value = null
            return false
        }
        return true;
    }

    checkMimeType = (e) => {
        let files = e.target.files
        let err = ''
        const types = ['application/pdf']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            return false;
        }
        return true;
    }

    /// README: SUBMITTING THE FORM
    handleSubmit = (e) => {
        e.preventDefault();

        const { title, description, elevationFiles } = this.state;
        const { downX, downY, project } = this.props;
        const { floorMeta } = project;

        if (elevationFiles.length < 1) {
            alert("Please attach at least 1 file to continue");
        } else {
            const isFirstOrder = true;
            this.props.addNewElevation(
                floorMeta.proid,
                floorMeta.floorid,
                [downX, downY],
                elevationFiles,
                title,
                description,
                isFirstOrder,
            )
        }
    }

    /// README: RENDER THE UI
    render() {
        const { title, descriptionCount, description, elevationFiles } = this.state;
        const { mut, formLabelStyle, snagDetail, commons } = this.props;
        const markerTitle = mut.text["1"];

        /// this is placed to pause snagDetail related stuff while snagDetail is not available
        if (!snagDetail) {
            return <React.Fragment/>
        }
        
        const relevantSubmitComponent =
            <button className="btn btn-dark btn-sm">Add this {markerTitle}</button>

        return (
            <React.Fragment>
                <form onSubmit={this.handleSubmit}>
                    {/* Title and description */}
                    <div className="form-group text-left">
                        <label htmlFor="inputText" style={formLabelStyle}>Title *</label>
                        <input type="text" className="form-control form-control-sm" id="newTitle" onChange={this.handleChange} defaultValue={title} required />
                    </div>
                    <div className="form-group text-left">
                        <label htmlFor="inputText" style={formLabelStyle}>Description *</label>
                        <span className="ml-3" style={{ fontSize: "12px", color: "GrayText" }}>({descriptionCount}/200)</span>
                        <textarea maxLength="200" rows="3" className="form-control form-control-sm" id="newDescription" onChange={this.handleChange} defaultValue={description} required />
                    </div>
                    <hr />
                    {/* File upload button */}
                    <div className="form-group text-left">
                        <label style={formLabelStyle}>Add {commons.drawings} *</label>
                        <br />
                        <label htmlFor="newElevationFiles">
                            <span role="button" className="btn btn-outline-dark btn-sm" >
                                Select PDF file(s)
                            </span>
                        </label>
                        <br />
                        <input type="file" className="file" id="newElevationFiles" multiple onChange={this.onFilesAddHandler} style={{ fontWeight: "bold", fontSize: "12px", display: "none" }} />
                    </div>
                    <div style={{ maxHeight: "160px", overflow: "hidden", overflowY: "auto" }}>
                        <ul className="list-group align-items-start list-group-flush">
                            {elevationFiles.map((fileName, i) => (
                                <li style={{ fontSize: "13px" }} className="list-group-item py-2 border-0" ng-repeat="i in filters" key={i}>
                                    <b>{i + 1}. </b>{`${fileName.name}`}
                                    <br></br>
                                    <span style={{ fontSize: "10px", color: "GrayText", fontStyle: "italic" }}>(Formatted as: {this.processFilenames(fileName.name)})</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <br />
                    <hr />
                    {relevantSubmitComponent}
                    <br />
                    <br />
                </form>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        floorMarkers: state.firestore.data.FloorMarkers,
        mut: state.marker,
        formLabelStyle: state.appControl.formLabelStyle,

        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addNewElevation: (proid, floorid, coordinates, selectedElevationFiles, title, description, isFirstOrder) => dispatch(addNewElevation(proid, floorid, coordinates, selectedElevationFiles, title, description, isFirstOrder)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewElevation)
